<ss-modal
  #modalConfirm
  [modalwidth]="modalWidth"
  [open]="openModal"
  [enableCloseOutside]="enableCloseOutside"
  [label]="headerTitle"
  [dynamicFade]="true"
  (closeClick)="onModalCloseClick($event)"
>
  <div slot="modal-body">
    <div class="flex flex-col items-center gap-5">
      @if (showAlertIcon) {
        <img [src]="'alert-big' | icon" alt="Archive" width="54px" />
      }
      <p class="light-font">
        {{ confirmMessage }}
      </p>
      @if (secondaryMessage) {
        <p class="light-font text-center">
          {{ secondaryMessage }}
        </p>
      }
      <!--  SELECTIONS BUTTONS  -->
    </div>
  </div>
  <div slot="modal-buttons" class="flex flex-row justify-end gap-3 my-4">
    @if (!cancelAsPrimaryOption) {
      <ss-button data-test="modal-confirm-btn" (click)="onConfirm()">{{
        confirmBtnLabel
      }}</ss-button>
      <ss-button
        data-test="modal-cancel-btn"
        props="normal secondary"
        (click)="onCancel()"
        >{{ cancelBtnLabel }}</ss-button
      >
    } @else {
      <ss-button (click)="onCancel()" data-test="modal-cancel-btn">{{
        cancelBtnLabel
      }}</ss-button>
      <ss-button
        props="normal secondary"
        (click)="onConfirm()"
        data-test="modal-confirm-btn"
        >{{ confirmBtnLabel }}</ss-button
      >
    }
  </div>
</ss-modal>
